import React, { useMemo, useState } from 'react';
import * as XLSX from 'xlsx';

const vazia = ordem => ({ id: ordem, area: '', cultura: '', hectares: '',
    produtividade: '', preco: '', custo: '' });

export default () => {
    const [safra, setSafra] = useState(`${new Date().getFullYear()}/${new Date().getFullYear() + 1}`);
    const [areas, setAreas] = useState([vazia(1)]);
    const alterar = (indice, campo, valor) => setAreas(areas.map((item, posicao) =>
        posicao === indice ? { ...item, [campo]: valor } : item));
    const calculadas = useMemo(() => areas.map(item => {
        const hectares = Number(item.hectares || 0);
        const receita = hectares * Number(item.produtividade || 0) * Number(item.preco || 0);
        const custo = hectares * Number(item.custo || 0);
        return { ...item, receita, custo_total: custo, resultado: receita - custo };
    }), [areas]);
    const total = calculadas.reduce((soma, item) => soma + item.resultado, 0);
    const exportar = () => {
        const livro = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(livro, XLSX.utils.json_to_sheet(calculadas), 'Planejamento');
        XLSX.writeFile(livro, `gestao_areas_${safra.replace('/', '-')}.xlsx`);
    };
    return <div>
        <div className='form-group col-md-3 pl-0'><label>Safra</label><input
            className='form-control' value={safra} onChange={e => setSafra(e.target.value)} /></div>
        <div style={{ overflowX: 'auto' }}><table className='table table-bordered table-sm'>
            <thead><tr><th>Área</th><th>Cultura</th><th>ha</th><th>Produtividade/ha</th>
                <th>Preço</th><th>Custo/ha</th><th className='text-right'>Resultado</th><th /></tr></thead>
            <tbody>{calculadas.map((item, indice) => <tr key={item.id}>
                {['area', 'cultura', 'hectares', 'produtividade', 'preco', 'custo'].map(campo =>
                    <td key={campo}><input className='form-control form-control-sm'
                        type={['hectares', 'produtividade', 'preco', 'custo'].includes(campo) ? 'number' : 'text'}
                        value={item[campo]} onChange={e => alterar(indice, campo, e.target.value)} /></td>)}
                <td className='text-right align-middle'>{item.resultado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                <td><button type='button' className='btn btn-sm btn-outline-danger'
                    onClick={() => setAreas(areas.filter((_, p) => p !== indice))}><i className='fas fa-trash' /></button></td>
            </tr>)}</tbody>
            <tfoot><tr><th colSpan='6'>Resultado estimado</th><th className='text-right'>
                {total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</th><th /></tr></tfoot>
        </table></div>
        <button type='button' className='btn btn-light mr-2'
            onClick={() => setAreas([...areas, vazia(Date.now())])}>Adicionar área</button>
        <button type='button' className='btn btn-success' onClick={exportar}>Exportar planejamento</button>
    </div>;
};
